import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SharedService } from "../../services/shared.service";

@Component({
  selector: 'app-RatingPage',
  templateUrl: './rating.page.html',
  styleUrls: ['./rating.page.scss'],
})

export class RatingPage {

  @Input() appointment: any;

  private rating = {
    rating: 0,
    comments: null
  };

  private ratingSubmitted: boolean = false;

  constructor(
    private sharedService: SharedService,
    private modalController: ModalController
  ) {

   }

  ngOnInit() {

  }

  ionViewWillLeave() {
    if(!this.ratingSubmitted) {
      this.submitRating(null);
    }

  }

  setRating(rating) {
    //alert('clicked');
    this.rating.rating = rating;

  }

  submitRating(rating) {

    if(rating == null) {
      this.rating.comments = null;
    }

    this.ratingSubmitted = true;

    this.modalController.dismiss();

    this.sharedService.connection.requestHttpPostCapacitor(this.sharedService.connection.generateRequestUrl('/submit_rating'),
    {
      auth_user_id: this.sharedService.currentUser.user_id,
      remember_token: this.sharedService.currentUser.remember_token,
      appointment_id: this.appointment.appointment_id,
      rating: rating
    }, function(response, component) {

      //alert(JSON.stringify(response.message));

      var data = JSON.parse(response.data);

      if(data.code == 200){
        console.log('Rating submitted.');
        console.log(response);

      } else if(data.code == 501) {
        component.sharedService.displayAcknowledgementIonAlert(data.message);
        //component.sharedService.presentToast(data.message, 'middle', 3000, 'toast');
      } else {
        //show error notification
        console.log(response);
      }
    }, function(err, component) {
      //alert(JSON.stringify(err));
      console.error('Error submitting rating... ' + JSON.stringify(err));

    }, this);
  }

  dismiss() {
    this.modalController.dismiss();
  }

}
